<div fxLayout="row" fxLayoutAlign="space-between center" style="border-bottom: 1px solid #e2e2e2">
    <mat-form-field>
        <mat-icon matPrefix>search</mat-icon>
        <input id="search-input" matInput type="text" placeholder="Search" [formControl]="search" />
    </mat-form-field>

    <button id="create-group-button" mat-button (click)="createNewGroup()">CREATE NEW GROUP</button>
</div>

<mat-spinner *ngIf="loading" diameter="48" mode="indeterminate" style="margin: 2rem auto;"></mat-spinner>

<div id="group-list" fxLayout="row">
    <cdk-virtual-scroll-viewport itemSize="72" style="height: 82vh;" fxFlex="35">
        <mat-action-list>
            <mat-list-item *cdkVirtualFor="let group of groups | searchGroups: search.value" (click)="select(group)" [ngClass]="{ selected: selected === group }">
                <div fxLayout="column">
                    <div matLine>
                        <b>{{ group.name }}</b>
                    </div>
                    <div [ngPlural]="group.members.length" matLine>
                        <ng-template ngPluralCase="=1">{{ group.members.length }} member</ng-template>
                        <ng-template ngPluralCase="other">{{ group.members.length }} members</ng-template>
                    </div>
                </div>
            </mat-list-item>
        </mat-action-list>
    </cdk-virtual-scroll-viewport>

    <div fxFlex *ngIf="selected && !editing" fxFlexAlign="start start">
        <div style="color: #385A4C; padding: 25px;">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <div class="group-name">
                    <div>{{ selected.name }}</div>
                    <div [ngPlural]="selected.members.length" matLine>
                        <ng-template ngPluralCase="=1">{{ selected.members.length }} member</ng-template>
                        <ng-template ngPluralCase="other">{{ selected.members.length }} members</ng-template>
                    </div>
                    <span><i>{{ selected.privateGroup ? 'private' : 'public' }}</i></span
          >
        </div>
        <span fxFlex></span>
                    <button mat-raised-button color="primary" (click)="editGroup()" [disabled]="!isOwner(selected)">
          EDIT
        </button>
                </div>
            </div>

            <div style="height: 68vh; overflow: auto;">
                <div style="padding-left: 10px;">
                    <div class="header-list">Owners</div>
                    <mat-list *ngIf="selected.owners.length > 0">
                        <mat-list-item *ngFor="let user of selected.owners | sort: ['lastName', 'firstName']" style="border-bottom: 1px solid #b4b4b4;">
                            <img src="assets/images/no-image.png" alt="avatar" matListAvatar />
                            <h3 matLine *ngIf="user.lastName || user.firstName">{{ user.lastName ? user.lastName + ',' : '' }} {{ user.firstName }}</h3>
                            <h3 matLine *ngIf="!user.lastName && !user.firstName">{{ user.email }}</h3>
                        </mat-list-item>
                    </mat-list>

                    <div class="header-list">Roster</div>
                    <mat-list>
                        <mat-list-item *ngFor="let user of selected.members | sort: ['lastName', 'firstName']" style="border-bottom: 1px solid #b4b4b4;">
                            <img src="assets/images/no-image.png" alt="avatar" matListAvatar />
                            <h3 matLine *ngIf="user.lastName || user.firstName">{{ user.lastName ? user.lastName + ',' : '' }} {{ user.firstName }}</h3>
                            <h3 matLine *ngIf="!user.lastName && !user.firstName">{{ user.email }}</h3>
                            <i *ngIf="!user.invited" style="margin-right: 10px;">Member</i>
                            <i *ngIf="user.invited" style="margin-right: 10px;">Pending</i>
                        </mat-list-item>
                    </mat-list>
                </div>

                <div *ngIf="selected.members.length < 1" style="padding: 25px;">
                    No members.
                </div>
            </div>
        </div>

        <div fxFlex *ngIf="selected && editing" fxFlexAlign="start start">
            <div style="color: #00308f; padding: 25px;">
                <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
                    <div>
                        <mat-form-field>
                            <input matInput type="text" placeholder="Name" [formControl]="groupName" />
                            <mat-error *ngIf="groupName.errors && groupName.errors.required">Group Name is required</mat-error>
                            <mat-error *ngIf="groupName.errors && groupName.errors.existingName">Group Name already exists</mat-error>
                        </mat-form-field>
                    </div>
                    <span fxFlex></span>
                    <button mat-raised-button color="primary" (click)="cancelEdit()">DONE</button>
                </div>
                <div fxLayout="row" fxLayoutGap="16px">
                    <button mat-raised-button color="accent" (click)="addMarines()">Add Marines</button>
                    <button mat-raised-button color="accent" (click)="addOwners()">Add Owners</button>
                    <mat-slide-toggle [formControl]="isPrivateGroup">Private</mat-slide-toggle>
                </div>
            </div>

            <div style="height: 68vh; overflow: auto;">
                <div style="padding-left: 10px;">
                    <div class="header-list">Owners</div>
                    <mat-list *ngIf="selected.owners.length > 0">
                        <mat-list-item *ngFor="let user of selected.owners | sort: ['lastName', 'firstName']" style="border-bottom: 1px solid #b4b4b4;">
                            <img src="assets/images/no-image.png" alt="avatar" matListAvatar />
                            <h3 matLine *ngIf="user.lastName || user.firstName">{{ user.lastName ? user.lastName + ',' : '' }} {{ user.firstName }}</h3>
                            <h3 matLine *ngIf="!user.lastName && !user.firstName">{{ user.email }}</h3>
                            <span fxFlex></span>
                            <div matTooltip="Cannot remove the only owner of the group" [matTooltipDisabled]="!onlyOwner(selected, user)">
                                <button mat-button color="warn" (click)="removeOwner(user)" [disabled]="onlyOwner(selected, user) || isRemoving(user.uuid)">
                Remove
              </button>
                            </div>
                        </mat-list-item>
                    </mat-list>

                    <div class="header-list">Roster</div>
                    <mat-list>
                        <mat-list-item *ngFor="let user of selected.members | sort: ['lastName', 'firstName']" style="border-bottom: 1px solid #b4b4b4;">
                            <img src="assets/images/no-image.png" alt="avatar" matListAvatar />
                            <h3 matLine *ngIf="user.lastName || user.firstName">{{ user.lastName ? user.lastName + ',' : '' }} {{ user.firstName }}</h3>
                            <h3 matLine *ngIf="!user.lastName && !user.firstName">{{ user.email }}</h3>
                            <i *ngIf="!user.invited" style="margin-right: 10px;">Member</i>
                            <i *ngIf="user.invited" style="margin-right: 10px;">Pending</i>
                            <span fxFlex></span>
                            <button mat-button color="warn" (click)="removeMember(user)" [disabled]="isRemoving(user.uuid)">
              Remove
            </button>
                        </mat-list-item>
                    </mat-list>
                </div>

                <div *ngIf="selected.members.length < 1" style="padding: 25px;">
                    No members.
                </div>
            </div>
        </div>
    </div>
    <ngx-guided-tour></ngx-guided-tour>